import { useBrPageContext } from "../../context/context/context.js";
import { getUrl } from "../../utils/utils/get-url.js";
function useBloomreachLinks(links = []) {
  const page = useBrPageContext();
  return mapBloomreachLinks(links, page);
}
const mapBloomreachLinks = (links, page) => {
  return links.map(({ url, label, style, openInNewWindow, alt }) => ({
    alt,
    label,
    style,
    url: getUrl(url, page) ?? "",
    target: openInNewWindow ? "external" : "internal"
  }));
};
export {
  mapBloomreachLinks,
  useBloomreachLinks
};
//# sourceMappingURL=use-bloomreach-links.js.map
